import type { RulesProps } from '@arco-design/web-react/es/Form/interface';
import type { TFunction } from 'i18next';

import i18n from '@/i18n';

const t = i18n.t.bind(i18n);

/** 生成带字段名的必填校验规则 */
export function maasRequiredRules(fieldName: string): RulesProps[] {
  const name = String(fieldName || '').trim() || t('common:required.field');
  return [{ required: true, message: t('common:validate.required', { name }) }];
}

/** 生成带字段名的下拉必选校验规则 */
export function maasRequiredSelectRules(fieldName: string): RulesProps[] {
  const name = String(fieldName || '').trim() || t('common:required.field');
  return [{ required: true, message: t('common:validate.required.select', { name }) }];
}

/** 实例级副本数：必填且不小于 min（模型实例直建/SKU/下单节点配置） */
export function maasInstanceReplicasRules(fieldName: string, min = 1): RulesProps[] {
  const name = String(fieldName || '').trim() || t('common:required.field');
  return [
    { required: true, message: t('common:validate.required', { name }) },
    {
      type: 'number',
      min,
      message: t('data-center:maas.replicas.min', { min }),
    },
  ];
}

/** MaaS 实例名称必填 + 最大长度 64 校验规则 */
export function maasAliasNameRules(fieldName: string): RulesProps[] {
  return [...maasRequiredRules(fieldName), { maxLength: 64, message: t('data-center:maximum.length.64') }];
}

/** 将校验 i18n key 格式化为可读文案（避免 {{name}} 占位符未替换） */
export function formatMaasFormError(
  translate: TFunction,
  errorKey: string,
  fieldLabelKey?: string,
  params?: Record<string, string | number>,
): string {
  if (errorKey === 'common:validate.required') {
    const name = fieldLabelKey ? translate(fieldLabelKey) : translate('common:required.field');
    return translate(errorKey, { name });
  }
  if (errorKey === 'common:validate.required.select') {
    const name = fieldLabelKey ? translate(fieldLabelKey) : translate('common:required.field');
    return translate(errorKey, { name });
  }
  return translate(errorKey, params);
}

/** 表单校验失败时的通用兜底提示 */
export const MAAS_FORM_VALIDATE_FALLBACK_KEY = 'components:please.fill.in.the.required.fields';

/** MaaS 创建流程输入框占位 */
export const MAAS_INPUT_PLACEHOLDER = t('common:input.placeholder', { name: '' });

/** MaaS 创建流程下拉占位 */
export const MAAS_SELECT_PLACEHOLDER = t('common:select.placeholder', { name: '' });
